const BODY_CLASS_KEYBOARD_OPEN = 'tg-keyboard-open'
const KEYBOARD_INSET_THRESHOLD = 80

let activeTeardown = null

function isTelegramWebApp() {
  return !!(window.Telegram?.WebApp?.initData || document.body.classList.contains('tg-webapp'))
}

function getKeyboardInset() {
  const vv = window.visualViewport
  if (!vv) return 0
  return Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop))
}

function applyKeyboardInset() {
  const inset = getKeyboardInset()
  const root = document.documentElement
  root.style.setProperty('--app-keyboard-inset', `${inset}px`)
  document.body.classList.toggle(BODY_CLASS_KEYBOARD_OPEN, inset > KEYBOARD_INSET_THRESHOLD)
}

/**
 * Keep layout stable when the mobile soft keyboard opens inside Telegram WebView.
 */
export function initTelegramWebViewLayout() {
  if (activeTeardown) return activeTeardown

  if (!isTelegramWebApp()) {
    return () => {}
  }

  const onViewportChange = () => {
    applyKeyboardInset()
  }

  applyKeyboardInset()
  window.addEventListener('resize', onViewportChange, { passive: true })

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewportChange, { passive: true })
    window.visualViewport.addEventListener('scroll', onViewportChange, { passive: true })
  }

  activeTeardown = () => {
    window.removeEventListener('resize', onViewportChange)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', onViewportChange)
      window.visualViewport.removeEventListener('scroll', onViewportChange)
    }
    document.documentElement.style.removeProperty('--app-keyboard-inset')
    document.body.classList.remove(BODY_CLASS_KEYBOARD_OPEN)
    activeTeardown = null
  }

  return activeTeardown
}

export function destroyTelegramWebViewLayout() {
  if (activeTeardown) {
    activeTeardown()
  }
}
